var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconCopy = function SvgIconCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.833 0.0833359H6.91634C6.04313 0.0833359 5.33301 0.793461 5.33301 1.66667V4.83334H2.16634C1.29313 4.83334 0.583008 5.54346 0.583008 6.41667V14.3333C0.583008 15.2065 1.29313 15.9167 2.16634 15.9167H10.083C10.9562 15.9167 11.6663 15.2065 11.6663 14.3333V11.1667H14.833C15.7062 11.1667 16.4163 10.4565 16.4163 9.58334V1.66667C16.4163 0.793461 15.7062 0.0833359 14.833 0.0833359ZM2.16634 14.3333V6.41667H10.083L10.0846 14.3333H2.16634ZM14.833 9.58334H11.6663V6.41667C11.6663 5.54346 10.9562 4.83334 10.083 4.83334H6.91634V1.66667H14.833V9.58334Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-copy.e2757aa3.svg";
export { ForwardRef as ReactComponent };